import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../../service';

@Injectable()
export class RoleGuardService implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedRoles = route.data.expectedRoles;

        if (this.authService.getUserToken()) {
            if (expectedRoles.indexOf(this.authService.getUserLoginRole()) >= 0) {
                return true;
            } else {
                return false;
            }
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}